var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotesClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1264 67.3257C35.855 67.3257 29.5833 60.8647 29.5833 51.2916C29.5833 42.6769 36.778 35.5 46.5227 35.5C57.1964 35.5 65.0833 44.1147 65.0833 57.2733C65.0833 87.1821 43.2745 99.1456 29.5833 100.583V87.4247C38.8666 85.7502 49.3036 76.4197 49.771 66.1247C49.3036 66.3613 47.4516 67.3257 45.1264 67.3257ZM92.4597 67.3257C83.1824 67.3257 76.9167 60.8647 76.9167 51.2916C76.9167 42.6769 84.1113 35.5 93.8561 35.5C104.53 35.5 112.417 44.1147 112.417 57.2733C112.417 87.1821 90.6078 99.1456 76.9167 100.583V87.4247C86.1999 85.7502 96.6369 76.4197 97.1043 66.1247C96.6369 66.3613 94.785 67.3257 92.4597 67.3257Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesClose);
export default __webpack_public_path__ + "static/media/quotes-close.87ee84f4ca923481165ca23898af87fd.svg";
export { ForwardRef as ReactComponent };